export const RANDOM_NAMES = [
  'Emilia',
  'Aqua',
  'Megumin',
  'Rem',
  'Holo',
  'Asuna',
  'Asuka',
  'Rei',
  'Akari',
  'Nagisa',
  'Mio',
  'Niko',
  'Honoka',
  'Eru',
  'Atsuko',
  'Yuno',
  'Satou'
]

export const RANDOM_SURNAME = [
  'Langley',
  'Akaza',
  'Kousaka',
  'Akiyama',
  'Yazawa',
  'Ayanami',
  'Furukawa',
  'Yuuki',
  'Chitanda',
  'Kagari',
  'Gasai',
  'Matsuzaka'
]

export const DEVICE_NAME = 'DEVICE_NAME'

export function getRandomInt(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getRandomName() {
  return RANDOM_NAMES[getRandomInt(0, RANDOM_NAMES.length - 1)] || RANDOM_NAMES[0]
}

export function getRandomSurname() {
  return RANDOM_SURNAME[getRandomInt(0, RANDOM_SURNAME.length - 1)] || RANDOM_SURNAME[0]
}

export function getDeviceId() {
  let deviceId = null
  if (typeof window !== "undefined") {
    deviceId = window.localStorage.getItem(DEVICE_NAME) ? JSON.parse(window.localStorage.getItem(DEVICE_NAME)) : null
    if (deviceId === null) {
      deviceId = `${getRandomName()} ${getRandomSurname()}`
      window.localStorage.setItem(DEVICE_NAME, JSON.stringify(deviceId))
    }
  }
  return deviceId
}
